var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeadset = function SvgHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .984c4.969 0 9 4.031 9 9v7.031c0 1.641-1.359 3-3 3h-3v-8.016h3.984V9.983c0-3.891-3.094-6.984-6.984-6.984S5.016 6.093 5.016 9.983v2.016H9v8.016H6a3.02 3.02 0 0 1-3-3V9.984c0-4.969 4.031-9 9-9z"
  })));
};
export default SvgHeadset;